module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row11_appleQRcode.aa7bc981.png";